import React from 'react';
import { useTheme } from 'styled-components';
import { Flex } from '@ui-library/flex';
import { XMark } from '@ui-library/icons';
import { BaseText, LargeText } from '@ui-library/typography';
import { Button } from '@ui-library/button';
import { StyledHeader } from './styles';

interface DrawerHeaderProps {
  title: React.ReactNode;
  subtitle?: React.ReactNode;
  extra?: React.ReactNode;
  showClose?: boolean;
  onClose?: () => void;
  ghost?: boolean;
}

const DrawerHeader: React.FC<React.PropsWithChildren<DrawerHeaderProps>> = ({
  title,
  subtitle,
  showClose = true,
  onClose,
  ghost,
  extra,
  children,
}) => {
  const theme = useTheme();

  return (
    <StyledHeader $ghost={ghost}>
      <Flex spaceBetween alignItemsCenter className="overflow-hidden">
        <LargeText
          style={{ fontWeight: 500 }}
          className="flex-1 text-ellipsis"
          title={typeof title === 'string' ? title : undefined}
        >
          {title}
        </LargeText>

        <Flex alignItemsCenter gap="0.5rem">
          {extra}
          {showClose && (
            <Button
              variant="next"
              level="tertiary"
              icon={<XMark />}
              onClick={onClose}
              aria-label="Close drawer"
            />
          )}
        </Flex>
      </Flex>
      {subtitle && <BaseText color={theme.token.next.palette.grey500}>{subtitle}</BaseText>}
      {children}
    </StyledHeader>
  );
};

export { DrawerHeader };
